<template>
  <div class="box box_book_detail">
    <search-box class="detail_search"></search-box>
    <div class="content">
      <keep-alive>
        <side class="left_side" :parents="parents"></side>
      </keep-alive>
      <div class="right">
        <div class="nav">
          <!-- 一级分类 -->
          <span
            class="nav_book"
            v-if="book.ppname"
            @click="pushside('','',book.ppid,'','',book.ppname,'1')"
          >
            <img
              class="icon_nav"
              v-if="book.ppname=='本土著述'"
              src="../../assets/public/ancientBooks/local_icon_nav_grey.png"
              alt
            />
            <img
              class="icon_nav"
              v-if="book.ppname=='域外著述'"
              src="../../assets/public/ancientBooks/outside_icon_nav_grey.png"
              alt
            />
            {{book.ppname}}
          </span>
          <!-- 二级分类 -->
          <span
            class="nav_middle"
            v-if="book.pname"
            @click="pushside('',book.pid,book.ppid,'',book.pname,book.ppname,'2')"
          >{{book.pname}}</span>
          <!-- 三级分类 -->
          <span
            class="nav_middle"
            v-if="book.category_name"
            @click="pushside(book.category_id,book.pid,book.ppid,book.category_name,book.pname,book.ppname,'3')"
          >{{book.category_name}}</span>
          <span class="nav_current">{{book.name}}</span>
        </div>
        <div class="detail_box">
          <div class="detail">
            <div class="detail_left">
              <img v-if="book.cover" height="" width="" :src="book.cover" alt="图书封面" />
              <!-- <img v-else src="../../assets/public/ancientBooks/book.png" alt=""> -->
            </div>
            <div class="detail_right">
              <div class="book_title">{{book.name}}</div>
              <div class="second_title">
                <span class="key">
                  作
                  <ins></ins>者：
                </span>
                <span class="name">{{book.author}}</span>
              </div>
              <!-- <div class="second_title"><span class="key">卷&nbsp;&nbsp;&nbsp;数：</span><span class="name">{{book.volumes}}</span></div> -->
              <div class="second_title">
                <span class="key">
                  时
                  <ins></ins>期：
                </span>
                <span class="name">{{book.dynasty}}</span>
              </div>
              <div class="second_title" v-show="book.version">
                <span class="key">版本项：</span>
                <span class="name">{{book.version}}</span>
              </div>
              <!-- <div class="second_title">
                <span class="key">馆藏地：</span>
                <span class="name" v-if="book.collect">{{book.collect}}</span>
                <span v-else class="name">不详</span>
              </div> -->
              <div class="second_title">
                <span class="key">
                  册
                  <ins></ins>数：
                </span>
                <span class="name">{{book.total_volumes}}</span>
              </div>
              <div class="second_title" v-if="show_num_books">
                <span class="key">所在册：</span>
                <span class="name">{{num_books}}册</span>
              </div>
              <div class="second_title" v-if="show_num_books">
                <span class="key">丛书名：</span>
                <span class="name">{{book.series_name}}</span>
              </div>
              <div class="dashed" v-if="book_volumes.length>1||(book_volumes.length==1 && volumeArr.length>=1)"></div>
              <div class="volumebox" v-if="book_volumes.length>1||(book_volumes.length==1 && volumeArr.length>=1)">
                <p class="volume_left">
                  分
                  <ins></ins>卷：
                </p>
                <div class="volume_right name">
                  <div v-for="(item,index) in book_volumes" v-bind:key="index" class="volume_li">
                    <p class="volume_li_name" v-if="item.details.length>=1">
                      {{item.name}}
                      <span></span>
                    </p>
                    <p v-else class="volume_li_name" @click="checkvolume(item.volume_id,)">{{item.name}}</p>
                    <div
                      v-show="item.details.length>=1"
                      class="volume_cli"
                    >
                      <p
                        v-for="(citem,cindex) in item.details"
                        :key="cindex"
                        @click="checkdetalis(item.volume_id,citem.detail_id)"
                      >
                        <i></i>
                        {{citem.content}}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <a v-else :class="{'clicked':isclick}" @click="startReading()">开始阅读</a>
            </div>
          </div>
          <!-- <div class="volumes" v-if="book_volumes.length>1||(book_volumes.length==1 && volumeArr.length>=1)">
              <div
                class="volume_li"
                v-for="(item,index) in book_volumes"
                v-bind:key="index"
                :class="item.volume_id==current_volume_id?'active':''"
              >
              <div class="volume_li_name"
                @click="changeVolume(item)">
                {{item.name}}
              </div>
                <div
                  v-show="volumeArr.length>=1&&item.volume_id==current_volume_id&&canread"
                  :class="[volume_cliwidth?'is12':'','volume_cli']"
                >
                  <p
                    :class="[citem.detail_id==detali_id?'isdid':'']"
                    v-for="(citem,cindex) in volumeArr"
                    :key="cindex"
                    @click="checkdetalis(citem.detail_id)"
                  >
                    <i></i>
                    {{citem.content}}
                  </p>
                </div>
            </div>
          </div>-->
        </div>
        <div class="comments_box">
          <div class="comments_title">
            留下您的心得
            <span></span>
          </div>

          <el-input
            v-if="!is_white"
            type="textarea"
            :autosize="{ minRows: 3}"
            placeholder="说说你的心得"
            v-model="comment"
          ></el-input>
          <button class="comment_confirm" v-if="!is_white" @click="addComments()">发表心得</button>
          <div class="comments">
            <div class="title">全部心得</div>
            <div class="comment" v-for="(item,index) in comments" v-bind:key="index">
              <div class="comment_title">
                <strong class="user">{{item.name}}</strong>
                <span class="date">{{item.publish_time}}</span>
              </div>
              <pre v-text="item.content" class="comment_content"></pre>
            </div>
            <div v-if="is_all" class="no_more">没有更多了</div>
            <div v-else class="more_info" @click="LoadMore">
              <div v-if="isLoading">
                <img src="../../assets/public/ancientBooks/loading.gif" alt="加载" />
              </div>
              <div v-else>查看更多</div>
            </div>
          </div>
        </div>
      </div>
      <div class="clear"></div>
    </div>

    <div class="guoqibox" v-if="isjump">
      <div class="guoqihead">
        <div class="gqleft">
          提示
        </div>
        <div class="gqcent">

        </div>
        <div class="gqright" @click="oksb">
          <img src="../../assets/index/icon_关闭@2x.png" alt="">
        </div>
      </div>
      <div class="guoqicenter">
        <div class="gqgt">
          <img src="../../assets/index/gantan.png" alt="">
        </div>
        <div class="gqwz">
          您的产品支持服务已经到期，将影响您的使用，<br>请与服务商联系！
        </div>
        <div class="gqbtn">
          <button @click="oksb1" class="gqbutton">我知道了</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import qs from 'qs';
import apiURL from "../../util/api";
import Side from "../public/side.vue";
import merge from "webpack-merge";
import { addstamp } from "../../util/stamp";
import searchBox from "../public/searchBox.vue";
export default {
  data() {
    return {
      comment: "",
      book: {},
      book_volumes: [],
      current_volume_id: null, //当前册id
      comments: [], //评论
      comments_current_page: 1, //评论当前页
      comments_page_size: 3, //评论每页个数
      comments_total_pages: null, //评论总页数
      is_all: false, //评论是否是全部
      parents: null,
      isLoading: false,
      isclick: false,
      is_white: null,
      isjump: false,
      ispermission: false,
      num_books: null,
      show_num_books: false,
      hispath: null,
      pushsideArr: {},
      img_count: 0,
      canread: true,
      volume_name: null,
      is_cuser: false,
      // volumeArr: {},
      // volume_cliwidth: true,
      detali_id: null
    };
  },
  metaInfo: {
    title: "千年医典数据库-科学支撑中医临床、教学科研、健康养生",
    meta: [
      { name: "keywords", content: "" },
      { name: "description", content: "千年医典数据库的中医古籍详情" }
    ]
  },
  components: {
    Side,
    searchBox
  },
  created() {
    this.is_white = this.$store.state.iswhitelist;
    // console.log('-------------')
    // this.book_id = this.$route.query.book_id;
    // console.log(this.book_id)
    // console.log('-------------')
    this.getBookDetail();
    this.getComments();
    const hashLocation = this.$route.path;
    //   const newLocation = hashLocation.split("#/")[1];
    const url = "https://www.kanguji.com" + hashLocation;
    this.$matomo.setCustomUrl(url); //覆盖页面报告的url，可以自定义页面url，加上本页面路由
    //   this.$matomo.trackEvent(shopCode,hashLocation);//事件
    // this.$matomo.trackPageView(hashLocation);//页面名称,可以自定义页面名称
  },

  mounted() {
    // if (window.history && window.history.pushState) {
    //   history.pushState(null, null, document.URL);
    //   window.addEventListener("popstate", this.goBack, false);
    // }
    // console.log(this.$router)
  },
  // destroyed() {
  //   window.removeEventListener("popstate", this.goBack, false);
  // },
  methods: {
    oksb(){
      this.isjump = false
    },
    oksb1(){
      this.$router.push({ path: "/login" });
    },
    pushside(
      id,
      pid,
      ppid,
      category_name,
      p_category_name,
      pp_category_name,
      level
    ) {
      // console.log("id:" + id);
      // console.log("pid:" + pid);
      // console.log("ppid:" + ppid);
      // console.log("category_name:" + category_name);
      // console.log("p_category_name:" + p_category_name);
      // console.log("pp_category_name:" + pp_category_name);
      // console.log("level:" + level);
      let parents = [];
      parents.push(
        id,
        pid,
        ppid,
        category_name,
        p_category_name,
        pp_category_name,
        level
      );
      // console.log(parents)
      this.parents = parents;
      // this.$router.push({name:'ancientBooks',params:{from:'check',level:level,id:id}})
    },
    goBack() {
      // this.$router.replace({ path: "/ancientBooks" });
      // this.$router.go(-2)
      //replace替换原路由，作用是避免回退死循环
    },
    getBookDetail() {
      let that = this;
      // let datas = {
      //   user_id: that.$store.state.user_id,
      // };
      let url = "";
      if (parseInt(that.$store.state.user_id)) {
        url =
          "book/info/" +
          that.$route.query.book_id +
          "?user_id=" +
          parseInt(that.$store.state.user_id) +
          "&ip=" +
          that.$store.state.ip;
      } else {
        url =
          "book/info/" +
          that.$route.query.book_id +
          "?ip=" +
          that.$store.state.ip;
      }

      that.$axios
        .get(url)
        .then(res => {
           console.log(res.data.data)
          if (res.data.status_code == 200) {
            that.book = res.data.data;
            that.book_volumes = res.data.data.book_volumes;
            that.img_count = res.data.data.book_volumes[0].total_count;
            that.num_books = res.data.data.book_volumes[0].num_books;
            that.show_num_books = res.data.data.book_volumes[0].show_num_books;
            let parents = [];
            parents.push(
              res.data.data.ppid,
              res.data.data.pid,
              res.data.data.category_id,
              res.data.data.ppname,
              res.data.data.pname,
              res.data.data.category_name,
              4
            );
            //                  console.log(parents)
            that.parents = parents;
            if (that.$route.query.volume_id) {
              that.current_volume_id = that.$route.query.volume_id;
            } else {
              that.current_volume_id = that.book_volumes[0].volume_id; //默认第一册
              that.volume_name = that.book_volumes[0].name;
              that.canread = that.book_volumes[0].is_buy;
              that.is_cuser = that.book_volumes[0].is_c_user;
              that.volumeArr = that.book_volumes[0].details;
              // if (that.volumeArr.length >= 1) {
              //   that.detali_id = that.volumeArr[0].detail_id;
              //   that.img_count = that.volumeArr[0].total_count;
              //   for (var i = 0; i < that.volumeArr.length; i++) {
              //     // console.log(i);
              //     if (that.volumeArr[i].content.length > 8) {
              //       that.volume_cliwidth = true;
              //       break;
              //     } else {
              //       that.volume_cliwidth = false;
              //     }
              //   }
              // }
              // that.$router.push({
              //   query: merge(this.$route.query, {
              //     volume_id: that.current_volume_id
              //   })
              // });
            }
            if (that.is_white) {
              that.canread = true;
            }
          } else {
            return false;
          }
        })
        .catch(function(err) {
          return false;
        });
    },
    changeVolume(item) {
      // console.log(item)
      this.current_volume_id = item.volume_id;
      this.volume_name = item.name;
      this.img_count = item.total_count;
      this.num_books = item.num_books;
      this.show_num_books = item.show_num_books;
      this.canread = item.is_buy;
      this.is_cuser = item.is_c_user;
      // this.volumeArr = item.details;
      // if (this.volumeArr.length >= 1) {
      //   this.detali_id = this.volumeArr[0].detail_id;
      //   this.img_count = this.volumeArr[0].total_count;
      //   for (var i = 0; i < this.volumeArr.length; i++) {
      //     // console.log(i);
      //     if (this.volumeArr[i].content.length > 8) {
      //       this.volume_cliwidth = true;
      //       break;
      //     } else {
      //       this.volume_cliwidth = false;
      //     }
      //   }
      // }
      if (this.is_white) {
        this.canread = true;
      }
      // this.$router.push({
      //   query: merge(this.$route.query, { volume_id: this.current_volume_id })
      // });
    },
    checkdetalis(vid,did) {
      // console.log(did);
      this.detali_id = did;
      this.current_volume_id = vid;
      this.startReading()
    },
    checkvolume(vid){
      this.current_volume_id = vid;
      this.startReading()
    },
    // 获取评论列表
    getComments() {
      let that = this;
      that.isLoading = true;
      let datas = {
        page: that.comments_current_page,
        page_size: that.comments_page_size
      };
      //          console.log(datas)
      that.$axios
        .get("comments/" + that.$route.query.book_id, {
          params: datas
        })
        .then(res => {
          if (res.data.status_code == 200) {
            // console.log(res.data.data)
            // that.comments_current_page = res.data.data.current_page
            that.isLoading = false;
            that.comments_total_pages = res.data.data.total_pages;
            if (that.comments_current_page == that.comments_total_pages) {
              that.is_all = true;
            }
            if (that.comments_current_page === 1) {
              that.comments = res.data.data.comments;
            } else {
              that.comments = that.comments.concat(res.data.data.comments);
            }
          } else {
            return false;
          }
        })
        .catch(function(err) {
          // console.log(err);
          return false;
        });
    },
    // 查看更多
    LoadMore() {
      if (this.comments_current_page < this.comments_total_pages) {
        this.comments_current_page += 1;
        this.getComments();
      } else {
        this.is_all == true;
      }
    },
    // 发表心得
    addComments() {
      //          console.log(this.comment)
      if (this.comment && this.comment !== "") {
        let that = this;
        let datas = {
          user_id: that.$store.state.user_id,
          content: that.comment,
          book_id: that.$route.query.book_id
        };
        var sign = addstamp(datas);
        delete datas.token;
        datas["sign"] = sign;
        // console.log(datas)
        that
          .$axios({
            method: "post",
            url: "comment/" + that.$route.query.book_id,
            data: datas,
            headers: {
              "Content-Type": "application/json"
            }
          })
          .then(res => {
            // console.log(res)
            if (res.data.status_code == 200) {
              that.comment = "";
              that.comments_current_page = 1;
              that.is_all = false;
              that.getComments();
            } else {
              alert("请先登录!");
              return false;
            }
          })
          .catch(function(err) {
            // console.log(err);
            alert("请先登录");
            return false;
          });
      }
    },
    isIE() { //ie?
      if (!!window.ActiveXObject || "ActiveXObject" in window)
      return true;
      else
      return false;
    },
    // 开始阅读
    startReading() {
      var that = this;
      this.isclick = true;
      // const loading = this.$loading({
      //   lock: true,
      //   text: "正在加载中...",
      //   spinner: "my-el-custom-spinner",
      //   background: "rgba(0, 0, 0, 0.7)"
      // });
      //   是白名单
      if (this.is_white) {
        // if( this.$store.state.isjump){
        //   this.isjump = this.$store.state.isjump;
        //   return false
        // }else {
          let pictureUrl = that.$router.resolve({
            path: "/picture",
            query: {
              name: that.book.name,
              author: that.book.author,
              volume_id: that.current_volume_id,
              book_id: that.$route.query.book_id,
              ct: that.img_count,
              detail_id: that.detali_id
            }
          });
          window.open(pictureUrl.href, "_blank");
        // }
      } else {
        // 不是白名单并且过期
        if( this.$store.state.isjump){
          this.isjump = this.$store.state.isjump;
          return false
        }
        that.isclick = false;
        if (that.$store.state.user_id) {
          var that = this;
          let params = {
            user_id: that.$store.state.user_id,
            volume_id: that.current_volume_id
          };
          var sign = addstamp(params);
          delete params.token;
          params["sign"] = sign;
          let isie = this.isIE()
          let baseURL = apiURL+ "/book/auth/" + that.current_volume_id;
          if(isie){
            that.$axios
              .get("/book/auth/" + that.current_volume_id, {
                params
              })
              .then(res => {
                console.log(res.data);
                // loading.close();
                if (res.data.status_code == 200) {
                  let pictureUrl = that.$router.resolve({
                    path: "/picture",
                    query: {
                      name: that.book.name,
                      author: that.book.author,
                      volume_id: that.current_volume_id,
                      book_id: that.$route.query.book_id,
                      ct: that.img_count,
                      detail_id: that.detali_id
                    }
                  });
                  window.open(pictureUrl.href, "_blank");
                } else {
                  alert("暂无查看权限，请联系管理员");
                }
              });

          }else{
            $.ajax({
              url: baseURL ,
              type: "GET",
              async: false,
              data: qs.stringify(params),
              timeout: 12000, //超时时间
              dataType: "json", //返回的数据格式：
              beforeSend: function(xhr) {},
              success: function(data, textStatus, jqXHR) {
                console.log(data)
                // loading.close();
                if (data.status_code == 200) {
                  let pictureUrl = that.$router.resolve({
                    path: "/picture",
                    query: {
                      name: that.book.name,
                      author: that.book.author,
                      volume_id: that.current_volume_id,
                      book_id: that.$route.query.book_id,
                      ct: that.img_count,
                      detail_id: that.detali_id
                    }
                  });
                  window.open(pictureUrl.href, "_blank");
                  // let open = window.open();
                  // open.location = pictureUrl
                } else {
                  alert("暂无查看权限，请联系管理员");
                }
              },
              error: function(xhr, textStatus) {},
              complete: function() {}
            });
          }
        } else {
          that.$router.push({ path: "/login" });
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped="" type="text/css">
.box_book_detail {
  padding-top: 30px;
  padding-bottom: 36px;
  background: #fff;
  .content {
    padding: 0 0 0 35px;
    box-sizing: border-box;
  }

  .guoqibox{
    width: 498px;
    height: 266px;
    background: #FFFFFF;
    box-shadow: 0px 1px 70px 0px rgba(0,0,0,0.15);
    border-radius: 13px;
    position: fixed;
    margin: auto;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 888;
    display: flex;
    flex-direction: column;
  }
  .guoqihead{
    width: 100%;
    height: 40px;
    background: #F0F0F0;
    display: flex;
    border-radius:13px  13px  0px  0px ;

  }
  .gqleft{
    width: 68px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
  }
  .gqcent{
    flex: 1;
  }
  .gqright{
    width: 68px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
      width: 24px;
      height: 24px;
    }
  }
  .guoqicenter{
    flex: 1;
    border-radius: 0 0 13px 13px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .gqgt{
    width: 100%;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 18px;
    margin-bottom: 23px;
    img{
      width: 45px;
      height: 45px;
    }
  }
  .gqwz{
    width: 100%;
    height: 59px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 32px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 25px;
  }
  .gqbtn{

    width: 100%;
    height: 56px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .gqbutton{
    width: 220px;
    height: 39px;
    background: #f0f0f0;
    font-size:16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    border-radius: 15px;
    border: none;
  }
  .clear {
    width: 100%;
    clear: both;
  }
}
.right {
  width: 844px;
  margin-left: 79px;
  float: left;
  // border:1px solid;
  .detail_box {
    background-color: #fff;
    padding-bottom: 50px;
    .detail {
      width: 100%;
      background: url("../../assets/public/ancientBooks/detail_bg@2x.png")
        no-repeat;
      background-size: 880px;
      // display: flex;
      &>div{
        display: inline-block;
      }
      .detail_left {
        width: 200px;
        height: 256px;
        margin-left: 80px;
        margin-top: 23px;
        // border: 1px solid red;
          vertical-align: top;
        img {
          // width:100%;
          height: 256px;

        }
      }
      .detail_right {
        // border: 1px solid red;
        line-height: 1;
        margin-left: 67px;
        margin-top: 23px;
        // border:1px solid;
        .book_title {
          font-size: 26px;
          line-height: 38px;
          font-weight: 500;
          margin-bottom: 12px;
          color: #333;
          // font-family:FZGB10;
          font-family: PingFangSC-Medium, sans-serif;
          font-weight: 500;
        }
        .second_title {
          line-height: 30px;
          font-size: 16px;
          // display: flex;
          span {
            display: inline-block;
            }
            .key {
              width: 90px;
              font-family: PingFangSC-Light, sans-serif;
              font-weight: 300;
              color: #666;
              ins {
                display: inline-block;
                width: 16px;
              }
            }
            .name {
              vertical-align: top;
              text-overflow: wrap;
              font-family: PingFangSC-Regular, sans-serif;
              font-weight: 400;
              width: 380px;
              color: #333;
            }
        }
          .dashed{
            width: 490px;
            height: 1px;
            background-image: linear-gradient(to right, #BFBFBF 0%, #BFBFBF 60%, transparent 40%);
            background-size: 8px 1px;
            background-repeat: repeat-x;
            margin-top: 20px;
            margin-left: -20px;
          }
        .volumebox{
          margin-left: -7px;
          font-size: 16px;
          .volume_left{
            display: inline-block;
            height: 44px;
            line-height: 44px;
            // width: 90px;
              font-family: PingFangSC-Light, sans-serif;
              font-weight: 300;
              color: #666;
              vertical-align: top;
              ins {
                display: inline-block;
                width: 16px;
              }
          }
          .volume_right{
            display: inline-block;
              text-overflow: wrap;
              font-family: PingFangSC-Regular, sans-serif;
              font-weight: 400;
              color: #333;
            width: 408px;
            position: relative;
            .volume_li{
              width: 102px;
              height: 44px;
              display: inline-block;
              // border: 1px solid red;
                cursor: pointer;
              .volume_li_name{
              line-height: 44px;
                width: 100%;
                text-align: center;
                span{
                  width: 14px;
                  height: 14px;
                  // border: 1px solid red;
                  display: inline-block;
                  vertical-align: initial;
                  background: url('../../assets/public/ancientBooks/vdown_icon@2x.png') no-repeat center center;
                  background-size: cover;
                }
              }
              .volume_cli{
                display: none;
                color: #666;
                background: #fff;
                border:1px solid rgba(220,220,220,1);
                position: absolute;
                left: 0;
                width: 408px;
                min-height: 130px;
                z-index: 99px;
                padding-top: 20px;
                padding-left: 20px;
                box-sizing: border-box;
                // display: flex;
                p{
                  width: fit-content;
                  display: inline-block;
                  margin-right: 20px;
                  margin-bottom: 20px;
                  line-height: 16px !important;
                  height: 16px;
                  &:hover{
                    color: #E6522B;
                  }
                }
              }
              &:hover{
                background: #E5E5E5;
                .volume_cli{
                  display: block;
                }
              }
            }
          }
        }
        a {
          width: 174px;
          height: 44px;
          display: block;
          text-align: center;
          line-height: 44px;
          // background: linear-gradient(
          //   0deg,
          //   rgba(255, 124, 90, 1),
          //   rgba(230, 82, 43, 1)
          // );
          background: #e6522b;
          border-radius: 4px;
          color: #fff;
          font-size: 18px;
          font-family: PingFangSC-Regular, sans-serif;
          font-weight: 400;
          margin-top: 20px;
          outline: none;
          border: none;
          cursor: pointer;
          box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14),
            0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
          transition: transform 0.15s;
          text-shadow: 1px 2px 1px rgba(77, 9, 36, 0.6);
        }
        .clicked {
          transform: translate(0, 1px) !important;
          transition: transform 0.15s ease;
          animation: input-shadow 0.15s ease;
          box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.14),
            0 1px 7px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -1px rgba(0, 0, 0, 0.2);
        }
      }
    }
    .volumes {
      margin-top: 10px;
      .volume_li {
        height: 32px;
        color: #999;
        position: relative;
        border: 1px solid #ddd;
        display: inline-block;
        border-radius: 16px;
        font-size: 14px;
        font-family: PingFangSC-Regular, sans-serif;
        font-weight: 400;
        margin: 20px 20px 0 0;
        &.active {
          background: linear-gradient(
            -55deg,
            rgba(255, 124, 90, 1),
            rgba(230, 82, 43, 1)
          );
          color: #fff;
          border: 1px solid transparent;
        }
        &:hover {
          background: linear-gradient(
            -55deg,
            rgba(255, 124, 90, 1),
            rgba(230, 82, 43, 1)
          );
          color: #fff;
          border: 1px solid transparent;
          .volume_cli {
            display: block;
          }
        }
        .volume_li_name {
          width: 100%;
          height: 100%;
          cursor: pointer;
          line-height: 30px;
          padding: 0 23px;
        }
        .volume_cli.is12 {
          width: 260px;
        }
        .volume_cli {
          display: none;
          position: absolute;
          overflow-y: scroll;
          top: 33px;
          left: 0;
          z-index: 999;
          width: 167px;
          height: 137px;
          border: 1px solid #dcdcdc;
          background: #fff;
          color: #999;
          border-radius: 8px;
          box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.1);
          p {
            width: 100%;
            height: 38px;
            line-height: 14px;
            box-sizing: border-box;
            padding: 12px 20px;
            margin: 0 auto;
            overflow: hidden;
            // border-bottom: 1px solid #dcdcdc;
            cursor: pointer;
            font-size: 14px;
            display: flex;
            i {
              display: block;
              width: 8px;
              height: 8px;
              background: #aaa;
              border-radius: 50%;
              margin-right: 10px;
              margin-top: 3px;
            }
            &:hover {
              background: #e5e5e5;
            }
            &:last-child {
              margin-bottom: 10px;
            }
            &:first-child {
              margin-top: 10px;
            }
          }
          .isdid {
            background: #e5e5e5;
          }
        }
      }
    }
  }
  .comments_box {
    background-color: #fff;
    .comments_title {
      width: 148px;
      font-size: 24px;
      font-family: Alibaba PuHuiTi;
      font-weight: bold;
      color: #333;
      // margin-left: 60px;
      margin-bottom: 20px;
      position: relative;
      z-index: 2;
      span {
        width: 100%;
        height: 6px;
        display: inline-block;
        position: absolute;
        bottom: 2px;
        left: 0;
        z-index: -1;
        background: #e6522b;
      }
    }

    .comment_confirm {
      width: 80px;
      height: 36px;
      background: linear-gradient(
        -55deg,
        rgba(255, 124, 90, 1),
        rgba(230, 82, 43, 1)
      );
      border-radius: 4px;
      font-size: 16px;
      font-family: PingFangSC-Light, sans-serif;
      font-weight: 300;
      color: #fff;
      margin-top: 10px;
      outline: none;
      border: none;
      float: right;
      cursor: pointer;
    }
    .comments {
      margin-top: 62px;
      .title {
        background: url("../../assets/public/ancientBooks/comment_icon@2x.png")
          no-repeat left center;
        background-size: 22px;
        padding-left: 30px;
        color: #333;
        font-family: PingFangSC-Light, sans-serif;
        font-weight: 300;
        margin-bottom: 22px;
      }
      .comment {
        border-bottom: 1px solid #f4f4f4;
        padding-bottom: 28px;
        margin-bottom: 28px;
        margin-right: 34px;
        .comment_title {
          line-height: 1;
          text-align: middle;
        }
        .user {
          font-size: 20px;
          color: #000;
          font-family: PingFangSC-Regular, sans-serif;
          font-weight: 400;
          margin-right: 15px;
        }
        .date {
          font-size: 16px;
          color: #999;
          font-family: PingFangSC-Light, sans-serif;
          font-weight: 300;
        }
        .comment_content {
          color: #666;
          font-size: 16px;
          line-height: 28px;
          margin-top: 19px;
          font-family: PingFangSC-Light, sans-serif;
          font-weight: 300;
        }
        pre {
          white-space: pre-wrap;
          word-wrap: break-word;
        }
      }
    }
  }
}
</style>

<style>
.el-loading-spinner .el-loading-text {
  color: #fff !important;
  letter-spacing: 1px;
  font-size: 13px;
}
.el-loading-spinner i {
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/page/bookDetail.vue